var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EntityBuilder } from '@/node_modules/@decahedron/entity/dist/index';
import { Entity, Type } from '@decahedron/entity';
import { MediaAsset } from 'packages/media/MediaAsset';
import Delta from 'quill-delta/dist/Delta';
var Result = /** @class */ (function (_super) {
    __extends(Result, _super);
    function Result() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonLabel = null;
        _this.buttonUrl = null;
        _this.title = null;
        _this.description = null;
        _this.mediaAsset = null;
        _this.category = null;
        _this.videoLink = '';
        return _this;
    }
    Object.defineProperty(Result.prototype, "categoryName", {
        get: function () {
            return ['?', 'A+', 'A', 'B', 'C'][this.category];
        },
        enumerable: false,
        configurable: true
    });
    Result.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (jsonData.hasOwnProperty('mediaAsset') && jsonData.mediaAsset) {
            this.mediaAsset = EntityBuilder.buildOne(MediaAsset, jsonData.mediaAsset);
        }
        return this;
    };
    Result.prototype.convertResultToDelta = function (result) {
        return new Delta(JSON.parse(result));
    };
    var _a;
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_a = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _a : Object)
    ], Result.prototype, "mediaAsset", void 0);
    return Result;
}(Entity));
export { Result };
